import { Control, FieldPath, FieldValues } from 'react-hook-form'

/**
 * RHFのcontrol, name
 *
 * example:
 * ```
 * <Controller
 *    name={props.c.name}
 *    control={props.c.control}
 * ```
 */
export type ControlProps = {
  c: {
    control: Control<any>
    name: string
  }
}

/** controlをanyで受け取る時の型チェック
 *
 * example:
 * ```
 * const getControl = helper.control.valid(control)
 * <SampleInput {...getControl('name')} />
 * ```
 */
export const valid =
  <TFieldValues extends FieldValues>(control: Control<TFieldValues>) =>
  <TName extends FieldPath<TFieldValues>>(name: TName): ControlProps => ({
    c: {
      control,
      name,
    },
  })
